import React from 'react';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Paper, Grid, Switch, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CanvasDraw from "react-canvas-draw";
import TripleToggle from '../layouts/TripleToggle';
const useStyles = makeStyles(theme => ({
  dialogContainer: {
    minWidth: "320px",
    textAlign: "center",
    paddingBottom: "5vh"
  },
  disclaimerSwitchWrapper: {
    marginTop: "1vh",
    marginBottom: "1vh",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center"
  },
  captionWrapper: {
    maxWidth: "80%",
    marginTop: "1vh",
    marginBottom: "2vh",
    padding: "2vh",
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center"
  },
  fieldTitle: {
    fontWeight: "bold"
  },
  choiceNo: {
    color: "red"
  },
  choiceYes: {
    color: "green"
  },
  canvasContainer: {
    border: "1px solid black",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "2vh"
  },
  passiveCanvasContainer: {
    height: "320px",
    width: "320px",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "2vh",
    border: "1px solid black",
    display: "none"
  },
  signatureContainer: {
    marginTop: "1vh",
    textAlign: "center",
    fontWeight: "bold",
    color: "red"
  }
}));
const MarketingDialog = props => {
  const classes = useStyles();
  const [noChoice, setNoChoice] = useState(true);
  const [agreements, setAgreements] = useState({
    opt_in_comm_sms: props.sms ? true : '',
    opt_in_comm_email: props.email ? true : '',
    // opt_in_comm_dm: props.dm ? true : '',
    opt_in_mkt_analysis: props.market ? true : '',
    signature: null
  });
  const handleToggle = (type, value) => {
    let booleanValue;
    switch (value) {
      case "1":
        booleanValue = true;
        break;
      case "0":
        booleanValue = false;
        break;
      default:
        break;
    }
    setAgreements({
      ...agreements,
      [type]: booleanValue
    });
  };
  useEffect(() => {
    let buttonInactive = false;
    for (let key in agreements) {
      if (agreements[key] === null || agreements[key] === '') {
        buttonInactive = true;
      }
      setNoChoice(buttonInactive);
    }
    console.log('agreements changed to ', agreements);
  }, [agreements]);
  const submitChoice = () => {
    props.sendChoice(agreements);
  };
  let myCanvasReference = null;
  let canvasDrawReference = null;
  const saveCanvas = () => {
    console.log("changing...");
    // console.log(canvasDrawReference.getSaveData());
    localStorage.setItem("savedDrawing", canvasDrawReference.getSaveData());

    // draw in the classic canvas
    if (myCanvasReference.getContext) {
      // use getContext to use the canvas for drawing                                       
      let sourceCanvasData = JSON.parse(localStorage.getItem("savedDrawing"));
      console.log(sourceCanvasData);
      console.log(sourceCanvasData.lines);
      var ctx = myCanvasReference.getContext('2d');
      ctx.lineWidth = 8;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      for (let i = 0; i < sourceCanvasData.lines.length; i++) {
        ctx.beginPath();
        let initialMoveDone = false;
        console.log(sourceCanvasData.lines[i].points);
        for (let j = 0; j < sourceCanvasData.lines[i].points.length; j++) {
          let currentX = sourceCanvasData.lines[i].points[j].x;
          let currentY = sourceCanvasData.lines[i].points[j].y;
          console.log('X[' + j + ']', currentX);
          console.log('Y[' + j + ']', currentY);
          if (!initialMoveDone) {
            ctx.moveTo(currentX, currentY);
            initialMoveDone = true;
          } else {
            ctx.lineTo(currentX, currentY);
          }
        }
        ctx.stroke();
      }
    }
    console.log("myCanvas", myCanvasReference.toDataURL());
    let base64Data = myCanvasReference.toDataURL();
    setAgreements({
      ...agreements,
      'signature': () => base64Data
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.dialogContainer
  }, /*#__PURE__*/React.createElement(Paper, {
    className: classes.captionWrapper
  }, "J.T. International (Romania) SRL \u2013 JTI (Bd. Dimitrie Pompei nr. 9-9A, sector 2, Bucuresti) va solicita acordul pentru prelucrarea datelor comunicate de dvs. mai sus sau obtinute din activitatile derulate de dvs. pe website-ul campaniei promotionale in scop de marketing - transmiterea de comunicari comerciale prin mijloacele descrise mai jos. Aveti dreptul de a va retrage oricand consimtamantul; in plus, va informam ca datele dvs. nu vor fi folosite pentru decizii bazate exclusiv pe prelucrare automata de natura a produce efecte juridice sau a va afecta intr-o masura semnificativa (art. 22 alin 1 si 4 din GDPR)."), /*#__PURE__*/React.createElement("div", {
    className: classes.disclaimerSwitchWrapper
  }, /*#__PURE__*/React.createElement(Grid, {
    component: "label",
    container: true,
    alignItems: "center",
    style: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.fieldTitle
  }, "Comunicare prin SMS")), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TripleToggle, {
    toggleAction: handleToggle,
    toggleType: "opt_in_comm_sms",
    yesLabel: "DA",
    noLabel: "NU",
    defaultValue: agreements["opt_in_comm_sms"]
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.disclaimerSwitchWrapper
  }, /*#__PURE__*/React.createElement(Grid, {
    component: "label",
    container: true,
    alignItems: "center",
    style: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.fieldTitle
  }, "Comunicare prin Email")), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TripleToggle, {
    toggleAction: handleToggle,
    toggleType: "opt_in_comm_email",
    yesLabel: "DA",
    noLabel: "NU",
    defaultValue: agreements["opt_in_comm_email"]
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.disclaimerSwitchWrapper
  }, /*#__PURE__*/React.createElement(Grid, {
    component: "label",
    container: true,
    alignItems: "center",
    style: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.fieldTitle
  }, "Particip la Studiul de Piata")), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(TripleToggle, {
    toggleAction: handleToggle,
    toggleType: "opt_in_mkt_analysis",
    yesLabel: "DA",
    noLabel: "NU",
    defaultValue: agreements["opt_in_mkt_analysis"]
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.signatureContainer
  }, /*#__PURE__*/React.createElement("p", null, "Semnati in cadran:")), /*#__PURE__*/React.createElement(CanvasDraw, {
    className: classes.canvasContainer,
    ref: canvasDraw => canvasDrawReference = canvasDraw,
    onChange: saveCanvas,
    brushRadius: 4,
    brushColor: "#000000",
    hideGrid: true,
    hideInterface: true,
    canvasWidth: 320,
    canvasHeight: 320
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.passiveCanvasContainer
  }, /*#__PURE__*/React.createElement("canvas", {
    width: "320",
    height: "320",
    ref: myCanvas => myCanvasReference = myCanvas
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: submitChoice,
    style: {
      marginTop: "3vh"
    },
    disabled: noChoice
  }, "Trimite"));
};
MarketingDialog.propTypes = {
  sendChoice: PropTypes.func,
  sms: PropTypes.number,
  email: PropTypes.number,
  dm: PropTypes.number,
  market: PropTypes.number
};
export default MarketingDialog;